import { render, staticRenderFns } from "./CreateTruckPage2.vue?vue&type=template&id=4319fe9c&scoped=true&"
import script from "./CreateTruckPage2.vue?vue&type=script&lang=js&"
export * from "./CreateTruckPage2.vue?vue&type=script&lang=js&"
import style0 from "./CreateTruckPage2.vue?vue&type=style&index=0&id=4319fe9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4319fe9c",
  null
  
)

export default component.exports